import api from "@/lib/api";
import { Card, fmt, btnLink, Empty } from "@/components/portal/PortalUI";
import { Bell } from "lucide-react";

export const StudentNotifications = ({ items, reload }) => (
  <Card title="Notifications & Messages" testid="student-notifications"
    action={<button className={btnLink} onClick={async () => { await api.post("/student/notifications/read-all"); reload(); }} data-testid="notifications-read-all">Mark all read</button>}>
    {items.length === 0 ? <Empty>No notifications yet.</Empty> : (
      <ul className="divide-y divide-navy/5">
        {items.map((n) => (
          <li key={n.id} className="flex gap-3 py-3" data-testid={`notification-${n.id}`}>
            <Bell size={18} className={n.read ? "text-navy/30" : "text-magenta"} />
            <div className="flex-1"><p className={`text-sm ${n.read ? "text-dark-text/70" : "font-bold text-navy"}`}>{n.title}</p>
              <p className="text-xs text-dark-text/60 mt-0.5">{n.message}</p></div>
            <span className="text-xs text-dark-text/40 whitespace-nowrap">{fmt(n.created_at)}</span>
          </li>
        ))}
      </ul>
    )}
  </Card>
);
